import './datepicker.css';
import { DateIntervalProps } from './types';
import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FieldValues, useController } from 'react-hook-form';

const DateIntervalPicker = <Form extends FieldValues>(
  props: DateIntervalProps<Form>,
): JSX.Element => {
  const { setStart, setEnd, startDate, endDate, excludeStartDate } = props;
  const {
    field: { value },
  } = useController(props);

  const onChange = (dates) => {
    const [start, end] = dates;
    setStart(start);
    setEnd(end);
  };

  return (
    <DatePicker
      value={value}
      selected={startDate}
      onChange={onChange}
      startDate={startDate}
      endDate={endDate}
      selectsRange
      selectsDisabledDaysInRange
      inline
      excludeDates={excludeStartDate && [startDate]}
    />
  );
};

export default DateIntervalPicker;
